/**
 * @generated SignedSource<<72ec337ac1316db0a817d07b173979ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhasesSection_phases$data = ReadonlyArray<{
  readonly node: {
    readonly id: string;
    readonly startYear: number | null;
    readonly startMonth: number | null;
    readonly startDay: number | null;
    readonly deadlineYear: number | null;
    readonly deadlineMonth: number | null;
    readonly deadlineDay: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"Phase_phase">;
  } | null;
  readonly " $fragmentType": "PhasesSection_phases";
}>;
export type PhasesSection_phases$key = ReadonlyArray<{
  readonly " $data"?: PhasesSection_phases$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhasesSection_phases">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PhasesSection_phases",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PhaseType",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Phase_phase"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deadlineYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deadlineMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deadlineDay",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PhaseTypeEdge",
  "abstractKey": null
};

(node as any).hash = "a3a1e41b337a74ca98ada39941800997";

export default node;
